// Companion resources for the Wealth At Any Age book.
// Add new items here — the ResourcesSection renders them automatically.
const RESOURCES = [
  {
    id: 'net-worth-tracker',
    title: 'Net Worth Tracker',
    description: 'Four-tab workbook: monthly net worth, income tracker, investment account summary, and debt tracker. Update monthly to see your wealth grow.',
    chapter: 'Chapter 1',
    icon: '📊',
    file: '/resources/Net_Worth_Tracker.xlsx',
    fileType: 'Excel',
    fileSize: '~45 KB',
    tags: ['Foundational', 'Monthly Use'],
  },
  {
    id: 'debt-avalanche',
    title: 'Debt Avalanche Calculator',
    description: 'Enter all your debts and it calculates months to pay off, total interest saved, and the exact payoff sequence. Shows the cost of minimum payments vs. the avalanche method.',
    chapter: 'Chapter 1 & 3',
    icon: '💳',
    file: '/resources/Debt_Avalanche_Calculator.xlsx',
    fileType: 'Excel',
    fileSize: '~38 KB',
    tags: ['Debt Elimination', 'Savings'],
  },
  {
    id: 'income-stack',
    title: 'Income Stack Dashboard',
    description: 'Track up to 12 income streams — salary, side hustles, dividends, rentals, royalties. Calculates your passive income ratio and shows what percentage each stream contributes.',
    chapter: 'Chapter 31',
    icon: '💹',
    file: '/resources/Income_Stack_Dashboard.xlsx',
    fileType: 'Excel',
    fileSize: '~40 KB',
    tags: ['Income Growth', 'Passive Income'],
  },
  {
    id: 'wealth-assessment',
    title: 'Wealth Assessment Workbook',
    description: 'Complete Chapter 1\'s full financial snapshot: net worth calculation across all asset classes, plus the 10-question risk tolerance quiz with automatic scoring and risk profile.',
    chapter: 'Chapter 1',
    icon: '📋',
    file: '/resources/Wealth_Assessment_Workbook.xlsx',
    fileType: 'Excel',
    fileSize: '~42 KB',
    tags: ['Starting Point', 'Risk Profile'],
  },
  {
    id: 'fi-calculator',
    title: 'FI Number Calculator',
    description: 'Enter your annual expenses, savings rate, and expected return — it calculates your Financial Independence number, years to FI, and the exact monthly investment required to retire on your timeline.',
    chapter: 'Chapter 25',
    icon: '🏁',
    file: '/resources/FI_Number_Calculator.xlsx',
    fileType: 'Excel',
    fileSize: '~36 KB',
    tags: ['Retirement', 'FIRE'],
  },
  {
    id: '90-day-planner',
    title: '90-Day Wealth Sprint Planner',
    description: 'Week-by-week structured planner for executing Chapter 33\'s 90-day sprint framework. Includes baseline capture, weekly action checklists, and a review template for your next sprint.',
    chapter: 'Chapter 33',
    icon: '🎯',
    file: '/resources/90_Day_Wealth_Sprint_Planner.xlsx',
    fileType: 'Excel',
    fileSize: '~44 KB',
    tags: ['Execution', 'Goal Setting'],
  },
  {
    id: 'savings-tracker',
    title: 'Savings Rate Tracker',
    description: 'Monthly savings rate tracker with annual totals, a target savings rate input, and a running view of how much you are investing vs. spending. The single most powerful wealth metric to track.',
    chapter: 'Chapter 7',
    icon: '💰',
    file: '/resources/Savings_Rate_Tracker.xlsx',
    fileType: 'Excel',
    fileSize: '~37 KB',
    tags: ['Budgeting', 'Monthly Use'],
  },
];

export default RESOURCES;
